import {metagApi} from '@/axios'
// 查询项目列表
export function projectList(sendData) {
    return metagApi({
        url: '/project/page',
        method: 'post',
        data: sendData
    })
}

// 导出项目
export function projectExport() {
    return metagApi({
        url: '/project/export/all',
        method: 'get',
        responseType: "blob"
    })
}


// 释放原始数据
export function projectRelease(id) {
    return metagApi({
        url: '/project/verifyRawData/'+id,
        method: 'get',
    })
}

// 删除项目
export function projectDel(id) {
    return metagApi({
        url: '/project/' + id,
        method: 'delete'
    })
}
// 编辑项目信息（类型+备注）
export function projectEdit(data) {
    return metagApi({
        url: '/project',
        method: 'put',
        data:data
    })
}
export function projectCustomerEdit(data) {
    return metagApi({
        url: '/project/customer/remark',
        method: 'put',
        data:data
    })
}
// / 更改项目的用户
export function projectChangeUser(data) {
    return metagApi({
        url: '/project/editUsers',
        method: 'put',
        data:data
    })
}
// 最后10条
export function projectLast_10_metag(){
    return metagApi({
        url: '/project/last-10',
        method: 'get',
    })
}

export function projectLivenessPage_metag(sendData){
    return metagApi({
        url: '/project/projectLivenessPage',
        method: 'post',
        data: sendData
    })
}

export function customerLivenessPage_metag(sendData){
    return metagApi({
        url: '/project/customerLivenessPage',
        method: 'post',
        data: sendData
    })
}
